<template>
  <div>
    <van-cell-group title="停车信息">
      <van-cell v-if="spot.needPlateNumber" title="请填写您的车牌号:" label="离场时可实现自动开闸放行">
        <plate-number-input v-model="lastPlate"></plate-number-input>
      </van-cell>
      <van-cell title="车牌号" v-if="!order.parkingSpotId" :value="order.plateNumber" />
      <van-cell title="停车地点" :value="order.parkingLotName + ' ' + (order.parkingSpotName || '')"/>
      <van-cell title="停车时间" :value="parkingPeriod" value-class="value-class" />
      <van-cell title="停车时长" :value="parkingTime | duration" value-class="value-class" />
      <div class="time-tips">*计算时, 不足1分钟按1分钟计算</div>
    </van-cell-group>
    <van-cell-group title="缴费信息">
      <van-cell title="应付金额(元)" :value="order.totalCharge" />
      <van-cell title="优惠券" value-class="value-class" is-link @click="couponSelectorVisable=true">
        <span>
          <span v-if="order.couponCodes">
            <span v-for="(coupon, key) in combinedUsingCoupons" :key="key">&nbsp;
              <van-tag color="#7232dd" >{{coupon.name}}</van-tag>
              <span v-show="coupon.count>1"> &times;{{coupon.count}}</span>
            </span>
          </span>
          <span v-else-if="payment.availableCouponCount" style="color: #2890f0">{{payment.availableCouponCount}}张可用</span>
          <span v-else>(无可用)</span>
        </span>
      </van-cell>
      <van-cell v-show="order.discount != 100" title="停车场折扣" :value="order.discount+'%'" />
      <van-cell size="large" is-link @click="chargeDetailVisable=true">
        <template #title>
          <span>合计</span> <small style="color: gray;">详情 <van-icon name="question-o" /></small>
        </template>
        <template>
          <span><span class="amount">{{order.actualCharge}}</span> 元</span>
        </template>
      </van-cell>
    </van-cell-group>
    <br />
    <van-notice-bar v-if="order.parkingSpotId" left-icon="info-o"  :scrollable="false" wrapable>
      <span>您正在支付解锁<strong class="red">{{order.parkingSpotName}}车位</strong>,请确认<strong class="red">{{order.parkingSpotName}}台板上面</strong>停放的是您的车辆, 以防解锁错车位!</span>
    </van-notice-bar>
    <van-notice-bar v-if="order.parkingSpotId" color="#1989fa" background="#ecf9ff" left-icon="info-o">
      支付解锁后, 请联系现场工作人员操作取车
    </van-notice-bar>
    <van-notice-bar v-else-if="timeTooShort" color="#1989fa" background="#ecf9ff" left-icon="info-o">
      当前停车时长未超过{{Math.round(order.charge.feeTime/60)}}分钟, 无需支付, 可免费离场
    </van-notice-bar>
    <van-notice-bar v-else color="#1989fa" background="#ecf9ff" left-icon="info-o">
      支付成功后, 请在{{order.leavingTimeout|duration}}内离场, 否则将重新计费
    </van-notice-bar>

    <van-goods-action>
      <van-goods-action-icon icon="replay" @click="close" text="退出" v-show="!isMiniProgram" />
      <van-goods-action-button type="warning" @click="payForFriend" :disabled="loading || !order.actualCharge" text="好友代付" />
      <van-goods-action-button type="danger" @click="pay" :disabled="loading || timeTooShort || !order.orderId">
        <span v-if="timeTooShort">无需支付</span>
        <span v-else>支付 ({{timeout|duration}})</span>
      </van-goods-action-button>
    </van-goods-action>

    <payment-share-popup v-model="showSharePopup" :tradeNo="tradeNo" @paid="onPaid"/>
    <van-dialog v-model="chargeDetailVisable" title="计费详情" show-cancel-button :show-confirm-button="false" cancel-button-text="确定">
      <div style="max-height:500px; overflow-y: scroll;">
        <charge-detail :charge="order.charge" />
      </div>
    </van-dialog>
    <van-action-sheet v-model="couponSelectorVisable" class="coupons-popup" :title="'待支付' + order.actualCharge + '元'">
      <van-overlay :show="loading" style="display: flex;align-items: center;justify-content: center;">
        <van-loading type="spinner" vertical>计算中....</van-loading>
      </van-overlay>
      <coupon-inputer :disable="loading" @code="onCouponCode"/>
      <div class="coupon-tips">请选择要使用的优惠券:</div>
      <div class="coupons-pannel">
        <van-list v-model="loading" :finished="couponFinished" :finished-text="coupons.length ? '没有更多了' : ''" @load="loadCoupons" >
          <!-- 临时兑换的券 -->
          <div v-if="showInputCoupon">
            <span class="coupon-cover">新</span>
            <coupon :coupon="coupon" @click="checkedCoupon" :checked="usingCoupons.map(x=>x.code).includes(coupon.code)" :selectable="coupon.applicable" />
          </div>
          <!-- 当前停车已使用了的券 -->
          <coupon v-for="item in usingCoupons" :key="item.code" :checked="usingCoupons.map(x=>x.code).includes(item.code)" :coupon="item" @click="checkedCoupon" :selectable="item.applicable" />
          <!-- 持有但未使用的券 -->
          <coupon v-for="item in coupons" :key="item.code" :checked="usingCoupons.map(x=>x.code).includes(item.code)" :coupon="item" @click="checkedCoupon" :selectable="item.applicable" />
          <van-empty v-if="!showInputCoupon && !usingCoupons.length && !coupons.length" image="search" description="没有可用优惠券" />
        </van-list>
      </div>
    </van-action-sheet>
  </div>
</template>

<script>
import { router } from "../router";
import qs from "query-string";
import { ActionSheet, Button, Cell, CellGroup, Dialog, Empty, GoodsAction, GoodsActionButton, GoodsActionIcon, Icon, List, Loading, NoticeBar, Overlay, Search, Tag, Toast } from "vant";
import dayjs from "dayjs";
import PlateNumberInputVue from '../components/PlateNumberInput.vue';
import ChargeDetailVue from '../components/ChargeDetail.vue';
import CouponVue, { coubineCoupons } from '../components/Coupon.vue';
import CouponInputer from '../components/CouponInputer.vue';
import PaymentSharePopup from '../components/PaymentSharePopup.vue';

let timer = null;

export default {
  components: {
    [CellGroup.name]: CellGroup,
    [Cell.name]: Cell,
    [Icon.name]: Icon,
    [Button.name]: Button,
    [Dialog.Component.name]: Dialog.Component,
    [NoticeBar.name]: NoticeBar,
    [ActionSheet.name] : ActionSheet,
    [Search.name] : Search,
    [List.name] : List,
    [Overlay.name] : Overlay,
    [Tag.name] : Tag,
    [Loading.name] : Loading,
    [GoodsAction.name] : GoodsAction,
    [GoodsActionButton.name] :GoodsActionButton,
    [GoodsActionIcon.name] : GoodsActionIcon,
    [Empty.name] : Empty,
    'plate-number-input' : PlateNumberInputVue,
    'charge-detail' : ChargeDetailVue,
    'coupon' : CouponVue,
    'coupon-inputer' : CouponInputer,
    'payment-share-popup' : PaymentSharePopup
  },
  data() {
    return {
      order: {
        charge: {}
      },
      payment: {},
      timeout: 10,
      ready : false,
      lastPlate: null,
      chargeDetailVisable : false,
      couponSelectorVisable: false,
      spot: {},
      couponCode: null,
      loading: false,
      coupon: null,
      coupons: [],
      usingCoupons : [],
      couponFinished : false,
      showSharePopup : false,
      tradeNo: null,
      isMiniProgram: false
    };
  },
  mounted() {
    const q = qs.parse(location.search);
    const { orderId } = q;
    const that = this;
    if (orderId) {
      this.getOrder(orderId);
    } else {
      this.$http.get("/member/parking_status").then(function (status) {
        if (status.parkingStatus == 1) {
          router.push("/leaving");
        } else if (status.parkingStatus == 0) {
          router.push("/parking?orderId=" + status.parkingOrderId);
          that.getOrder(status.parkingOrderId);
        } else {
          router.push("/orders");
        }
      });
    }
    this.$wechat.sdk(sdk => {
        sdk.miniProgram.getEnv(function(res) {
          that.isMiniProgram = res.miniprogram;
        })
    });
  },
  beforeDestroy() {
    clearInterval(timer);
  },
  methods: {
    async checkedCoupon(checked, code){
      this.loading = true;
      const url = checked ? '/coupon/use_coupon' : '/coupon/unuse_coupon';
      const { orderId, parkingLotId } = this.order;
      try {
        await this.$http.post(url, { orderId, parkingLotId, code });
      } catch (e){
        console.log(e)
      } finally {
        this.prepareOrder(orderId);
      }
      
    },
    async onCouponCode(code) {
      const { parkingLotId, orderId } = this.order;
      try {
        this.loading = true;
        const newCoupon = await this.$http.get("/coupon/code_for_use", { code, parkingLotId, orderId }).then(data=>data.result);
        if (this.coupons.map(x => x.code).includes(newCoupon.code) || this.usingCoupons.map(x => x.code).includes(newCoupon.code)) {
          Toast('已在列表中');
        } else {
          this.coupon = newCoupon;
        }
      } finally{
        this.loading = false;
      }

    },
    onPaid () {
      this.getOrder(this.order.orderId);
    },
    async getOrder(orderId) {
      const data = await this.$http.get("/order", { orderId });
      if (!data) {
        router.push("/orders");
      } else if (data.parkingStatus == 1) {
        router.push("/leaving");
      } else if (data.parkingStatus != 0) {
        router.push("/orders?status=2");
      } else if (!data.scanValid) {
        Dialog.confirm({
          message: "缴费信息已过期, 请重新扫描车架上的二维码",
          confirmButtonText: "扫一扫",
        }).then(() => {
          router.push("/scan");
        });
      } else {
        this.order = data || {};
        if (this.order.orderId && !this.timeTooShort) {
          // 超出了免费时间才计费
          this.prepareOrder(this.order.orderId);
        }
        if (this.order.parkingSpotId) {
          this.spot = await this.$http.get('/parking/parking_spot', {parkingSpotId:this.order.parkingSpotId});
          if (this.spot.needPlateNumber && this.order.plateNumber) {
            this.lastPlate = this.order.plateNumber;
          }
        }
      }
    },
    close() {
      this.$wechat.sdk(sdk => sdk.closeWindow());
    },
    loadCoupons(){
      this.loading = true;
      const { parkingLotId, orderId } = this.order;
      const that = this;
      Promise.all([
        this.$http.get('/coupon/applicables', { parkingLotId, orderId }),
        this.$http.get("/coupon/order_coupons", { orderId })
      ]).then(([availables, using]) => {
        that.coupons = availables || [];
        that.usingCoupons = using || [];
      }).finally(() => {
        that.loading = false;
        that.couponFinished = true;
      });
      
    },
    intervalCheck() {
      if (this.timeout <= 1) {
        clearInterval(timer);
        console.log('重定向parking', this.timeout)
        router.push("/parking?orderId=" + this.order.orderId);
      } else {
        this.timeout -= 1;
      }
    },
    async prepareOrder(orderId) {
      this.loading = true;
      try {
        const { order, ...rest } = await this.$http.post("/order/prepare", { orderId }) || {};
        this.payment = rest || {};
        this.order = order || {}
        clearInterval(timer);
        this.timeout = this.payment.paymentTimeout;
        timer = setInterval(this.intervalCheck, 1000);
        this.loadCoupons();
      } finally{
        this.loading = false;
        this.ready = true;
      }
    },
    async pay(){
      this.loading = true;
      try {
        this.tradeNo = this.tradeNo || await this.$http.post('/order/pay', { orderId: this.order.orderId, plateNumber : this.lastPlate }).then(x => x.result);
        
        const callback = window.location.pathname + window.location.search;
        router.push('/payment?tradeNo='+this.tradeNo+'&callback=' + encodeURIComponent(callback));
      } finally {
        this.loading = false;
      }
    },
    async payForFriend() {
      this.tradeNo = this.tradeNo || await this.$http.post('/order/pay', { orderId: this.order.orderId, plateNumber : this.lastPlate }).then(x => x.result);
      this.showSharePopup = true;
    }
  },
  computed: {
    combinedUsingCoupons() {
      return coubineCoupons(this.usingCoupons);
    },
    parkingPeriod() {
      const start = dayjs(this.order.startTime);
      const end = dayjs(this.order.endTime);
      return (
        start.format("M月D日HH:mm") +
        " - " +
        end.format("M月D日HH:mm")
      );
    },
    timeTooShort() {
      // 停车时间不足30分钟 且费用0元 且是道闸缴费,则不能缴费,防止蹭免费离场时间
      return this.order.parkingTime < this.order.charge.feeTime && !this.order.actualCharge && !this.order.parkingSpotId && this.order.parkhostOnline;
    },
    parkingTime() {
      return  Math.ceil(this.order.parkingTime / 60) * 60;
    },
    showInputCoupon() {
      return this.coupon && !this.coupons.map(x => x.code).includes(this.coupon.code) && !this.usingCoupons.map(x => x.code).includes(this.coupon.code)
    }
  },
};
</script>

<style lang="less" scoped>
.value-class{
  flex: 4;
}
.coupons-popup{
  display: flex;
  flex-direction: column;
}
.coupons-pannel {
  background-color:#f7f8fa;
  padding-top: 5px;
}
.amount {
  color: red;
  font-size: 2em;
  font-weight: bold;
}
.time-tips {
  padding: 2px 15px;
  color: #999;
  text-align: right;
  font-size: 12px;
}
.coupon-tips {
  padding: 0 10px;
  color: gray;
}
.coupon-cover{
  display: inline-block;
  position: absolute;
  color: white;
  background-color: red;
  padding: 4px 3px;
  margin-left: 10px;
  border-bottom-left-radius: 10px;
  border-bottom-right-radius: 10px;
}
.red {
  color: red;
  font-weight: bold;
}
</style>